import React from "react";

const Delete = props => {
  let classes = "fa fa-trash text-danger";
  return (
    <i
      onClick={props.onClick}
      style={{ cursor: "pointer" }}
      className={classes}
      aria-hidden="true"
    />
  );
};

export default Delete;
